// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Hosting Prices',
  subtitle: 'Manage hosting package prices',
  addNew: 'New Package',
  edit: 'Edit',
  packageName: 'Package Name',
  packageType: 'Package Type',
  purchasePrice: 'Purchase Price',
  salePrice: 'Sale Price',
  currency: 'Currency',
  status: 'Status',
  actions: 'Actions',
  noPrices: 'No packages defined yet',
  noPricesDesc: 'Start by adding your first package.',
  noPricesHint: 'No prices defined yet. Start by adding your first package.',
  priceAdded: 'Package successfully added',
  priceUpdated: 'Package successfully updated',
  priceDeleted: 'Package successfully deleted',
  fetchError: 'Packages could not be retrieved',
  addError: 'Package could not be added',
  updateError: 'Package could not be updated',
  deleteError: 'Package could not be deleted',
  confirmDelete: 'Are you sure you want to delete this package?',
  typeShared: 'Shared Hosting',
  typeVps: 'VPS',
  typeDedicated: 'Dedicated',
  typeReseller: 'Reseller',
  typeCloud: 'Cloud',
  typeOther: 'Other',
  profit: 'Profit',
  listTitle: 'Hosting Package List',
  addTitle: 'Add New Hosting Package',
  editTitle: 'Edit Hosting Package',
  selectHosting: 'Select Server',
  manualEntry: 'Manual Entry',
  noServers: 'No servers available',
  noServersHint: 'Add servers from the Servers page first',
  packageNamePlaceholder: 'Ex: Basic Hosting, Premium Hosting',
  autoFillHint: 'Package name is automatically filled when server is selected',
  addPrice: 'Add Package',
  infoText: 'Define prices for hosting packages. When adding a server, the package name is automatically filled.',
  serversLoadError: 'Servers could not be loaded',
  addSuccess: 'Package successfully added',
  updateSuccess: 'Package successfully updated',
  deleteSuccess: 'Package successfully deleted',
  statusUpdateSuccess: 'Status successfully updated',
  statusUpdateError: 'Status could not be updated',
  gold: 'Gold'
};
